module.exports = __webpack_public_path__ + "static/media/dummy.66a52beb.pdf";